import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { PartesDiaTurno } from 'constants/index'

const ParteDiaFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <>
      <Form.Group>
        <Form.Label text='PARTE DIA' htmlFor='input-parteDia' md={4} alignRightAt='md' />
        <Col md={8}>
          {PartesDiaTurno.__array.map(x => (
            <Field key={x.id} name='parteDia'>
              {({ field }) => (
                <Form.Radio
                  {...field}
                  value={x.id}
                  checked={iValue === x.id}
                  disabled={fIsSubmitting}
                  id={`radio-${x.id}`}
                  label={x.nombre}
                />
              )}
            </Field>
          ))}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ParteDiaFormGroup)
